
import React from 'react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-flashlight-line',
      title: 'Instant Energy Boost',
      description: 'Experience immediate energy enhancement with 100% bioavailable vitamins delivered directly to your bloodstream.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Immune System Support',
      description: 'Strengthen your immune defenses with high-dose vitamin C, zinc, and powerful antioxidants.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Rapid Hydration',
      description: 'Achieve optimal hydration faster than oral intake with direct cellular delivery of fluids and electrolytes.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Enhanced Recovery',
      description: 'Accelerate recovery from illness, workouts, or stress with targeted nutrient combinations.'
    },
    {
      icon: 'ri-sun-line',
      title: 'Skin Health & Beauty',
      description: 'Improve skin radiance and health with collagen-supporting vitamins and antioxidants.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Mental Clarity',
      description: 'Enhance cognitive function and mental focus with brain-supporting B-vitamins and nutrients.'
    },
    {
      icon: 'ri-scales-line',
      title: 'Weight Management',
      description: 'Support healthy metabolism and weight management with targeted nutrient combinations.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Detoxification Support',
      description: 'Aid your body\'s natural detox processes with glutathione and liver-supporting nutrients.'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Experience the Power of <strong>IV Vitamin Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover the immediate and lasting benefits of direct nutrient delivery for optimal health and wellness.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 lg:p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl p-8 lg:p-12 text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4 lg:mb-6">
              Ready to Feel Your Best?
            </h3>
            <p className="text-lg lg:text-xl mb-6 lg:mb-8 opacity-90 max-w-2xl mx-auto">
              Join thousands of patients who have transformed their health with our premium IV vitamin therapies.
            </p>
            <button className="bg-white text-orange-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Book Your IV Treatment
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
